import React, { Component } from "react";
import PlaceHolder from "./placeholder";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
class App extends Component {  
  render() {
     return <PlaceHolder />
}
}
export default App;
